import { InjectionKey } from "@lib/svelte-typed-context";

import MasonryController from "./MasonryController";

export const masonryControllerToken: InjectionKey<MasonryController> = Symbol(
    "masonryControllerToken"
);
